import type { Control, FieldPath, FieldValues } from 'react-hook-form';

import { DateTimePicker } from '@/components/ui/datetime-picker';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';

interface FormDateTimePickerFieldProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  label: string;
  placeholder?: string;
  description?: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

export const FormDateTimePickerField = <TFieldValues extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  description,
  required,
  disabled,
  className,
}: FormDateTimePickerFieldProps<TFieldValues>) => (
  <FormField
    control={control}
    name={name}
    render={({ field }) => (
      <FormItem className={className}>
        <FormLabel>
          {label} {required && <span className="text-primary">*</span>}
        </FormLabel>
        <FormControl>
          <DateTimePicker
            value={field.value as string | undefined}
            onChange={field.onChange}
            placeholder={placeholder}
            disabled={disabled}
          />
        </FormControl>
        {description && <FormDescription>{description}</FormDescription>}
        <FormMessage />
      </FormItem>
    )}
  />
);
FormDateTimePickerField.displayName = 'FormDateTimePickerField';
